export default "__VITE_ASSET__R8I8y_Me__"